import { MouseEvent } from 'react';
import { preventDefaultAndNavigateToUrl } from '@zageno/ui';
import { Page } from './api';

export function navigateToUrlAndPreventDefault(page: Page, event: MouseEvent<HTMLAnchorElement>) {
  if (!page.external) {
    preventDefaultAndNavigateToUrl(event);
  }
}
